import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class SbInterceptorInterceptor implements HttpInterceptor {
    constructor() {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                // console.log(error);
                let errorTitle = '';
                let errorMsg = '';
                // if client side error
                if (error.error instanceof ErrorEvent) {
                    errorMsg = `Error: ${error.error.message}`;
                } else {
                    switch (error.status) {
                        case 0: {
                            errorTitle = `Cannot connect to the server`;
                            errorMsg = `Please check your internet connection.`;
                            break;
                        }
                        case 400: {
                            errorTitle = `Request contains errors`;
                            errorMsg = error.error;
                            break;
                        }
                        case 401: {
                            errorTitle = `Unauthorized`;
                            errorMsg = error.error;
                            break;
                        }
                        case 403: {
                            errorTitle = `Access Denied`;
                            errorMsg = error.error;
                            break;
                        }
                        case 404: {
                            errorTitle = `Not Found`;
                            errorMsg = `Sorry, the page you are looking for could not be found`;
                            break;
                        }
                        case 409: {
                            errorTitle = `Conflict`;
                            errorMsg = error.error;
                            break;
                        }
                        case 422: {
                            errorTitle = `Could not load data`;
                            errorMsg = error.error;
                            break;
                        }
                        case 500: {
                            errorTitle = ``;
                            errorMsg = `The server encountered an unexpected condition that prevented it from fulfilling the request.`;
                            break;
                        }
                        case 503: {
                            errorTitle = `Service Unavailable`;
                            errorMsg = `The server is currently unable to handle the request`;
                            break;
                        }
                        case 504: {
                            errorTitle = ``;
                            errorMsg = `Please check your internet connection and try again`;
                            break;
                        }
                        default: {
                            errorTitle = ``;
                            errorMsg = `An unknown server error occurred`;
                            break;
                        }
                    }
                }
                return throwError({ title: errorTitle, message: errorMsg, error: error });
            })
        );
    }
}
